import * as signalR from "@microsoft/signalr";

//连接集线器
let connection = new signalR.HubConnectionBuilder()
    //请求一次后端接口,保证是可通信的状态,即状态码为101
    .withUrl("https://api-wfb-gxq.cdfirst.net/hubs/bigScreen")
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Error) //日志输出级别,可自行调整
    .build();

async function start() {
    try {
        await connection.start();
    } catch (err) {
        setTimeout(start, 5000);
    }
};

connection.onclose(start);

start();

//订阅API ReceiveMessage方法 
export default {
    noticeMessage(ruleName, callback) {
        connection.on(ruleName, (data) => {
            callback(data);
        });
    }
}